import React from "react";
import t from "utils/Lang";
import "./index.scss";

type MenuActionsProps = {
  gettingCurrentLocation: boolean;
  getCurrentPosition: () => void;
  loading: boolean;
  togglePinLocation: () => void;
  pinMode?: boolean;
  pinLocationMode?: boolean;
};

const MenuActions = ({
  getCurrentPosition,
  gettingCurrentLocation,
  loading,
  togglePinLocation,
  pinMode,
  pinLocationMode,
}: MenuActionsProps) => {
  return (
    <div className="base-map__menu-container">
      {!pinLocationMode && (
        <button className="menu__location-button" onClick={getCurrentPosition}>
          {gettingCurrentLocation
            ? t().map__getting_location
            : t().map__location}
        </button>
      )}
      {pinMode && (
        <button className="menu__location-button" onClick={togglePinLocation}>
          {pinLocationMode ? "Xong" : "Chọn vị trí trên bản đồ"}
        </button>
      )}
      {loading && (
        <span className="menu__location-button ml10">Đang tải dữ liệu...</span>
      )}
    </div>
  );
};

export default MenuActions;
